/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ValidationFieldRequestDTO = {
    fieldName?: ValidationFieldRequestDTO.fieldName;
    fieldValue?: string;
};

export namespace ValidationFieldRequestDTO {

    export enum fieldName {
        PHONE_NUMBER = 'PHONE_NUMBER',
    }


}

